import React  from 'react'
import Body from "../Body"
import Footer from "../Footer/index"
import   "./Layout.css"

function Layout() {
 return (
<div className="container">
  <header>
    <h1 style={{fontSize:"2.5rem"}}>Kevin shikuku <sub>_under graduate</sub></h1>
  </header>

  <Body/>
  <Footer/>
</div>
 )
}

export default Layout
